
import React from "react";
import { Badge, Breadcrumb, Button, Calendar, Col, Divider, FloatButton, List, Modal, Row, Typography, message } from "antd";
import { Link } from "react-router-dom";

import { IoAddOutline, IoPencil, IoTrash } from "react-icons/io5";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";

import dayjs from "./pt-br.json";

class AgendaList extends React.Component {

    state = {
        _navigate: false,
        _loading: true,
        _params: window.location.href.split('/'),
        _type: this.props.type === 'list' ? 'Lista' : 'Lixeira',
        day: '',
        week: '',
        data_select: [],
        data: []
    }

    back = this.props.url;

    componentDidMount = () => {
        titleWeb('Agenda')
        this.renderData()
    }

    renderData = async () => {
        this.setState({loading: true})
        await POST_API('/schedule/search.php', { token: getToken() }).then(rs => rs.json()).then(async res => {
            this.setState({data: res.data})
        }).finally(f => {
            this.setState({loading: false})
        })
    }

    onAction = (ID, type, title) => {
        var self = this
        Modal.confirm({
            title: title,
            icon: <ExclamationCircleOutlined />,
            cancelText: 'Não',
            okText: 'Sim',
            onOk() {
                POST_API('/schedule/del.php', { token: getToken(), ID: ID, type: type, selected: JSON.stringify(self.state.table_select) }).then(rs => rs.json()).then(res => {
                    if (res.return) {
                        message.success({ content: res.msg, key: 'screen' })
                        if (type === 'del-select' || type === 'rec-select') self.setState({table_select: []})
                        self.onModal()
                        self.renderData()
                    } else {
                        message.warning({ content: res.msg, key: 'screen' })
                    }
                }).catch(() => {POST_CATCH()   }).finally(() => self.setState({_loading: false}))
            },
            onCancel() {},
        })
        
    }

    getListData = (value) => {
        let listData = [];
        var valor = value.format('YYYY-MM-DD')

        this.state.data.map(async item => {
            if (item.DATE === valor) {
                listData.push({type: `${item.SCHEDULE_TYPE_COLOR}`, content: item.DESC})
            }
        })

        return listData || [];
    };

    dateCellRender = (current, info) => {
        if (info.type === 'date') {
            const listData = this.getListData(current);
            return (
                <ul className="events">
                    {listData.map(item => (
                        <Typography className="event-list" style={{backgroundColor: item.type}}>{item.content}</Typography>
                    ))}
                </ul>
            );
        };

    };

    onRender = async (values) => {

        const semana = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];
        const valor = values.format('YYYY-MM-DD')

        this.setState({
            title: values.date(),
            week: semana[values.format('d')]
        })

        await POST_API('/schedule/search.php', { token: getToken(), filter: JSON.stringify({ DATE: valor }) }).then(rs => rs.json()).then(async res => {
            this.setState({ data_select: res.data })
        })

        this.onModal()
    }

    onModal = () => {
        this.setState({modal: !this.state.modal});
    };
    
    render = () => {

        const routes = this.props.bread

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={this.props.bread} className="bread-page" />
                    <Link to="novo"><FloatButton className="float-button add2" icon={<IoAddOutline color="#FFF" size={25} />}/></Link>
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={this.props.bread} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={'novo'}><Button type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small" style={{marginRight: 5}}>Novo</Button></Link>
                            { this.props.bread.length > 3 ? <Link to={this.props.ret}><Button type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link> : null }
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Calendar cellRender={this.dateCellRender} locale={dayjs} fullscreen onSelect={this.onRender} />
                    </Row>
                </Col>
                <Modal className="calendar_modal" open={this.state.modal} closable={false} footer={null} onCancel={this.onModal}>
                    <Row>
                        <Col span={24}>
                            <Typography className="calendar_date">{this.state?.title}</Typography>
                            <Typography className="calendar_week">{this.state?.week}</Typography>
                        </Col>
                    </Row>
                    <Divider className="calendar_divider" />
                    <Row>
                        <Col span={24} className="calendar_list">
                        { this.state.data_select.length > 0 ? (
                            <Row>
                                <Col span={24}>
                                    <List
                                        itemLayout="horizontal"
                                        dataSource={this.state.data_select}
                                        renderItem={item => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    title={<Badge color={item.SCHEDULE_TYPE_COLOR} text={item.DESC} />}
                                                    description={`${item.TIME_FOMRAT} - ${item.CREDENTIAL_NAME}`}
                                                />
                                                <Link to={item.ID}><Button className='table__btn table__btn_edit' style={{marginLeft: 8, marginRight: 8}} type="primary" shape="circle" size="small"><IoPencil /></Button></Link>
                                                <Button onClick={() => this.onAction(item.ID, 'del', 'Excluir registro?')} className='table__btn table__btn_delete' type="primary" shape="circle" size="small"><IoTrash /></Button>
                                            </List.Item>
                                        )}
                                    />
                                </Col>
                            </Row>
                        ) : (
                            <Row justify="center" className="calendar_row_no_data">
                                <Col span={24}>
                                    <Typography className="calendar_no_data">Não há compromissos marcados</Typography>
                                    <Typography className="calendar_no_data">para esse dia</Typography>
                                </Col>
                            </Row>
                        ) }
                        </Col>
                    </Row>
                </Modal>
            </Row>
        )

    }

}

export default AgendaList;